import React from "react";
import "./Footer.css";
import logo from "./logo-smsnc.png";

export default function Footer() {
  return (
    <div className="app-footer">
      <img src={logo} alt="SMSNC Logo" className="footer-logo" />
      <span>Powered by <strong>SMSNC</strong></span>
    </div>
  );
}
